class slideHelper {
    constructor() {

    }

    glide(el) {
        var glide = new Glide('.glider', {
            type: 'slider',
            perView: 3,
            autoplay: false,
            animationDuration: 400,
            breakpoints: {
                1330: {perView: 2},
            },

        }).mount();

        var glideId = el.id;

        var numOfSlides = document.getElementsByClassName('glide__slide').length;
        document.getElementById('prev' + glideId).disabled = true;

        glide.on(['mount.after', 'run'], function () {
            if (glide.index == 0) {
                document.getElementById('prev' + glideId).disabled = true;
            } else {
                document.getElementById('prev' + glideId).disabled = false;
            }
            if (glide.index == numOfSlides - 3) {
                document.getElementById('next' + glideId).disabled = true;
            } else {
                document.getElementById('next' + glideId).disabled = false;
            }
        });

        $('.show-hover').on('click', function (el) {
            var content = $(this).closest('.glide__slide');
            $(content).find('.case-study-card').addClass('show');
        })
    }

    singleGlide(el) {
        if (document.getElementById(el.id)) {
            new Glide('.glide', {
                type: 'slider',
                perView: 1,
                autoplay: 10000,
                hoverpause: true,
                animationDuration: 400,
            }).mount();
        }
    }

    imageGallery() {
        $('.image-thumbnail').on('click', function () {
            var target = $(this).attr('data-target');
            $('.main-image').fadeOut();
            setTimeout(function () {
                $(target).fadeIn();
            }, 500)
        });
    }
}

window
    .app
    .add(
        'slide'
        ,
        new

        slideHelper()
    )
;